<template>
  <div class="px-4">
      <v-row>
        <v-col>
          <div class="primary1--text headline font-weight-bold">
            E-MAIL ÁREAS
          </div>
        </v-col>
      </v-row>
    <TabelaEmailAreas
      @showBotaoPendencia="value => mostrarBotao = value"
      @reenviar="reenviar"
      @botao="value => mostrarBotao = value"
      @loading="value => loading = value"
      @tirarBotao="value => mostrarBotao = value"
      :reloadTable="reloadVar"
      ref="tabelaEmailAreas"
    />

    <v-row justify="end" v-if="!loading">

      <v-col cols="auto" class="mt-10" v-if="mostrarBotao">
        <button-cadu :width="200" text="REENVIAR TODOS" @click="reenviarPendentes" />
      </v-col>

      <v-col cols="auto" class="mt-10">
        <button-cadu
          @click="$router.push('/home')"
          text="VOLTAR"
          :backColor="$vuetify.theme.themes.light.primary2"
        />
      </v-col>

    </v-row>

    <SucessoModal
      :genericMessage="'E-mails reenviados com sucesso!'"
      :showSucess="showSucess"
      @close="carregar"
    />

    <SucessoModal
      :genericMessage="'Sua solicitação de reenvio de e-mails pendentes foi iniciada com sucesso, o processo irá continuar em segundo plano.'"
      :showSucess="showSucessTodos"
      @close="carregar"
    />

    <overlay-loading v-model="isLoading" />
    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import EmailAreas from '../../../services/EmailArea/EmailArea'
import { EventBus } from '../../../services/EventBus/EventBus'

const TabelaEmailAreas = () =>
  import(
    /* webpackChunkName: "TabelaEmailAreas" */ './Shared/TabelaEmailAreas'
  )
export default {
  components: {
    TabelaEmailAreas
  },

  data () {
    return {
      showBotao: true,
      showSucess: false,
      showSucessTodos: false,
      isLoading: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      reloadVar: false,

      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      mostrarBotao: true,
      loading: false,
      tirarBotao: false
    }
  },

  methods: {
    async reenviar (selecionados) {
      this.isLoading = true
      let emailArea = new EmailAreas(
        this.tokenBearer,
        this.$appConfig.config.API
      )
      try {
        await emailArea.putReenviarEmails(selecionados)
        this.showSucess = true
        this.isLoading = false
      } catch (err) {
        console.error(err)
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    carregar () {
      this.showSucess = false
      this.showSucessTodos = false
      EventBus.$emit('reloadTabelaEmailAreas', true)
    },

    async reenviarPendentes () {
      if (this.$refs.tabelaEmailAreas.rows <= 0) return
      let emailArea = new EmailAreas(
        this.tokenBearer,
        this.$appConfig.config.API
      )
      const args = this.$refs.tabelaEmailAreas.args()
      this.isLoading = true
      try {
        await emailArea.putReenviarPendente(args)
        this.showSucessTodos = true
        this.isLoading = false
      } catch (err) {
        console.error(err)
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    }
  }
}
</script>

<style>
</style>
